import React from "react";
import { useHistory } from "react-router-dom";
//icons
//Logo
import { ReactComponent as LogoSVG } from "../../assets/svg/akinrobotics-logo.svg";

//Components
export default function Header() {
  const history = useHistory();
  function PushRoute(value) {
    history.push(value);
  }

  function Exit() {
    PushRoute("/");
    localStorage.removeItem("jwtHeader");
  }

  return (
    <div className="flex h-12 w-full border-b-2 items-center justify-center">
      <div className="flex-1 ">
        <div>
          <LogoSVG
            className="h-10 w-16 ml-4  cursor-pointer "
            onClick={() => PushRoute("/home")}
          />
        </div>
      </div>
      <div className="flex-none flex items-center justify-center mr-6">
        <div
          onClick={() => Exit()}
          className=" mx-4   text-[15px] hover:text-blue-500 cursor-pointer"
        >
          Çıkış Yap
        </div>
      </div>
    </div>
  );
}
